import { Badge } from "@/components/ui/badge";
import { TRACKS } from "@/lib/constants";
import { HeartPulse, Briefcase, Users, Music } from "lucide-react";

const ICONS = { mental_behavioral_health: HeartPulse, corporate_hr_people_ops: Briefcase, nonprofits_education_community: Users, early_childhood_music: Music };

export function TrackBadge({ track, short = false, className = "" }) {
  const t = TRACKS[track];
  if (!t) return null;
  const Icon = ICONS[track];
  return (
    <Badge
      variant="outline"
      data-testid={`track-badge-${track}`}
      className={`gap-1.5 font-medium ${t.badge} ${className}`}
    >
      <Icon className="h-3 w-3" />
      {short ? t.short : t.label}
    </Badge>
  );
}
